/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3JlZGlyZWN0L3ByZXNlbnRhdGlvbi9yZWRpcmVjdC1ob21lL3JlZGlyZWN0LWhvbWUtY29udHJvbGxlci5jb21wb25lbnQuY3NzIn0= */"];
export { styles as styles };
